const KYouthAbout = () => {
  return (
    <div
      id="about"
      style={{
        scrollMarginBlockStart: 500,
      }}
      className=" eduvibe-home-four-about edu-about-area about-style-2 edu-section-gap bg-color-white"
    >
      <div className="container eduvibe-animated-shape">
        <div className="row row--50">
          <div className="col-lg-6">
            <div className="about-image-gallery">
              <div className="eduvibe-about-1-img-wrapper">
                <img
                  className="image-1"
                  src={`${process.env.PUBLIC_URL}/k-youth/assets/about-1.jpeg`}
                  alt="About Images"
                />
                <span className="eduvibe-about-blur">
                  <img
                    src="/k-youth/images/about/about-07/about-blur.png"
                    alt="About Blur"
                  />
                </span>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inner mt_md--40 mt_sm--40">
              <div className="section-title text-start">
                {/* <span className="pre-title">About Us</span> */}
                <h3 className="title" style={{ fontSize: 32, fontWeight: 900 }}>
                  K-YOUTH DEVELOPMENT PROGRAMME 2026
                </h3>
              </div>
              <p
                className="description mt--40 mt_md--20 mt_sm--20"
                style={{
                  textAlign: "justify",
                }}
              >
                K-Youth is a youth employability initiative by Khazanah Nasional
                Berhad aimed at developing Malaysia{"'"}s future-ready talent.
                The programme equips youth with industry-relevant skills,
                practical experience, and on-the-job training to enhance their
                employability in an increasingly competitive and evolving job
                market.
                <br />
                <br />
                Designed to bridge the gap between education and industry,
                K-Youth focuses on high-impact sectors such as digital and
                technology, semiconductors, and other key growth industries.
                Participants gain hands-on exposure and valuable insights that
                prepare them for real-world career opportunities.
                <br />
                <br />
                K-Youth reflects Khazanah{"'"}s commitment to nation-building
                through its “Advancing Malaysia” strategy and the “A Nation That
                Creates” framework, which emphasises capacity and community
                development. The programme also supports the aspirations of
                Malaysia MADANI by fostering innovation, strengthening workforce
                readiness, and contributing to Malaysia{"'"}s long-term economic
                growth.
              </p>

              <div className="read-more-btn mt--40">
                <a
                  className="edu-btn"
                  href="https://kyouth.pepperlabs.my"
                  target="_blank"
                >
                  APPLY NOW
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="row row--50" style={{ marginTop: 100 }}>
          <div className="col-lg-6">
            <div className="inner mt_md--40 mt_sm--40">
              <div className="section-title text-start">
                {/* <span className="pre-title">About Us</span> */}
                <h3 className="title" style={{ fontSize: 40, fontWeight: 900 }}>
                  ABOUT THE PROGRAMME
                </h3>
              </div>
              <p
                className="description mt--40 mt_md--20 mt_sm--20"
                style={{
                  textAlign: "justify",
                }}
              >
                A future-ready apprenticeship for Digital and Technology
                careers, with focused upskilling in AI competencies. Blending
                industry-recognised certifications with applied AI capstone
                projects, the programme develops both technical mastery and
                critical employability skills.
                <br />
                <br />
                Through immersive industry exposure and structured mentorship,
                our K-Youths graduate ready to perform, adapt, and lead in a
                fast-moving, digitally driven, and sustainability-focused global
                economy.
              </p>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="about-image-gallery">
              <div className="eduvibe-about-1-img-wrapper">
                <img
                  className="image-1"
                  src={`${process.env.PUBLIC_URL}/k-youth/assets/about-2.jpeg`}
                  alt="About Images"
                />
                <span className="eduvibe-about-blur">
                  <img
                    src="/k-youth/images/about/about-07/about-blur.png"
                    alt="About Blur"
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="row row--50" style={{ marginTop: 100 }}>
          <div className="col-lg-6">
            <div className="about-image-gallery">
              <div className="eduvibe-about-1-img-wrapper">
                <img
                  className="image-1"
                  src={`${process.env.PUBLIC_URL}/k-youth/assets/about-3.png`}
                  alt="About Images"
                />
                <span className="eduvibe-about-blur">
                  <img
                    src="/k-youth/images/about/about-07/about-blur.png"
                    alt="About Blur"
                  />
                </span>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inner mt_md--40 mt_sm--40">
              <div className="section-title text-start">
                {/* <span className="pre-title">About Us</span> */}
                <h3 className="title" style={{ fontSize: 40, fontWeight: 900 }}>
                  Your Journey Start Here
                </h3>
              </div>
              <p
                className="description mt--40 mt_md--20 mt_sm--20"
                style={{
                  textAlign: "justify",
                }}
              >
                No experience? Your career starts now. Pepper Labs{"'"} K-Youth
                Development Programme is a 4-month paid apprenticeship designed
                to prepare you for the workforce.
                <br />
                <br />
                Gain real-world experience, hands-on training, and
                industry-recognised certifications while working with leading
                companies. More than just a training programme, this is your
                launchpad into a meaningful career.
              </p>
              <div style={{ display: "flex", gap: 30 }}>
                <img
                  style={{ maxHeight: 50 }}
                  src={`${process.env.PUBLIC_URL}/k-youth/assets/logo/khazanah.png`}
                  alt="khazanah"
                />
                <img
                  style={{ maxHeight: 50 }}
                  src={`${process.env.PUBLIC_URL}/k-youth/assets/logo/pepperlabs.png`}
                  alt="pepperlabs"
                />
              </div>
            </div>

            <div className="read-more-btn mt--40">
              <a
                className="edu-btn"
                href="https://kyouth.pepperlabs.my"
                target="_blank"
              >
                EXPLORE COURSES
              </a>
            </div>
          </div>
        </div>

        <div className="shape-dot-wrapper shape-wrapper d-xl-block d-none">
          <div className="shape-image shape-image-1">
            <img
              src="/k-youth/images/shapes/shape-11-05.png"
              alt="Shape Thumb"
            />
          </div>
          <div className="shape-image shape-image-2">
            <img
              src="/k-youth/images/shapes/shape-08-01.png"
              alt="Shape Thumb"
            />
          </div>
          <div className="shape-image shape-image-3">
            <img src="/k-youth/images/shapes/shape-30.png" alt="Shape Thumb" />
          </div>
          <div className="shape shape-1">
            <span className="shape-dot"></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KYouthAbout;
